import { ProgramArea } from '../program-area';
import { FTE } from './fte';

export class ConditionChangeFTE
{
	constructor(
		public readonly programArea: ProgramArea,
		public readonly fte: FTE){ }

	public static fromJson(o: any): ConditionChangeFTE[] {
		return (<any[]>o).map(o => {
			let pa = ProgramArea.fromJson(o.programArea);
			let fte = FTE.fromJson(o.fte);
			return new ConditionChangeFTE(pa, fte);
		});
	}
}

export class ConditionChangeFTEDto {
	constructor(
		public programAreaId: number,
		public fte: number){ }
}
